"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const React = require("react");
const common = require("@grandvisionhq/common");
const irisUi = require("@grandvisionhq/iris-ui");
;/* empty css                                        */
function _interopNamespaceCompat(e) {
  if (e && typeof e === "object" && "default" in e) return e;
  const n = Object.create(null, { [Symbol.toStringTag]: { value: "Module" } });
  if (e) {
    for (const k in e) {
      n[k] = e[k];
    }
  }
  n.default = e;
  return Object.freeze(n);
}
const React__namespace = /* @__PURE__ */ _interopNamespaceCompat(React);
const FeatureTogglesControlPanelTrigger = () => {
  const { open } = common.useDrawer();
  return /* @__PURE__ */ React__namespace.createElement(
    irisUi.IconButton,
    {
      icon: "Code",
      onPress: open,
      className: "feature-toggles-control-panel-trigger feature-toggles-control-panel-trigger--sticky",
      "aria-label": "Open feature toggle control panel"
    }
  );
};
exports.FeatureTogglesControlPanelTrigger = FeatureTogglesControlPanelTrigger;
//# sourceMappingURL=FeatureTogglesControlPanelTrigger.js.map
